// extracted by mini-css-extract-plugin
export default {"tag_container":"styles_tag_container__YiQV1","actions":"styles_actions__xad34","delete":"styles_delete__5tPQg"};